import axios from "axios";

export async function saveEvidenceAPI(action) {
    const metaData = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
    };

    var data = new FormData();
    data.append("unique_name", action.uniqueName);
    data.append("file", action.pictureData);

    return new Promise((resolve) => {
        axios.post(`${process.env.REACT_APP_BACKEND}/evidence`, data, metaData)
            .then((response) => {
                resolve({"status": response.status});
            })
            .catch((e) => {
                resolve(e.response.data);
            }
        )
    });
}